export const environment = {
  production: true,
  baseUrl: 'https://efarm.cm/',
  apiUrl: 'https://efarm.cm:8443',
  liveApiUrl: 'https://efarm.cm:8443/',
  appTitle: ' | efarm.cm - Agricultural Marketplace',
  apiUsername: 'payunit_NzajDpri9',
  apiPassword: 'b142a723-bba3-4c11-bfdf-3567533cef26',
  apiKey: 'ae9c4d040eaa9c65b372a5ab888ab1fb53844f21',
  mode: 'live',
  return_url: 'https://efarm.cm/payment/return',
  notify_url: 'https://efarm.cm:8443/payments/return',
  purchaseRef: '',
  total_amount: '',
  name: 'eFarm.cm Market Place',
  currency: 'XAF',
  // image_cdn_url: 'https://awkamyaulq.cloudimg.io/v7',
  image_cdn_url: 'https://efarm.cm:8443',
  appName: 'EWeb',
  flutterwaveKey: 'FLWPUBK-841497264b77555804504fac7ef0a761-X',
  companyNumber: '681763523',
  fixerKey: 'fd63b536fa83182bfc5ea0ad979f9ad3',
  exchangeRateApiKey: 'ca039b9e0c82e80097c310f6',
  allowedHosts: ['localhost', '127.0.0.1', 'efarm.cm', 'www.efarm.cm', '45.33.6.65']
};
